module.exports = __webpack_public_path__ + "static/media/Klymit-Web-Destop-blog.b02a95e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Klymit/Klymit-Web-Destop-blog.jpg
// module id = 598
// module chunks = 0